exports = module.exports = require("../../../../_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cube-swipe-item{position:relative}.cube-swipe-item-inner{height:1.6rem;line-height:1.6rem;font-size:.426667rem;padding-left:.533333rem}.cube-swipe-btn{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;position:absolute;top:0;left:100%;height:100%;text-align:left;font-size:.426667rem}.cube-swipe-btn .text{-webkit-box-flex:1;-webkit-flex:1;flex:1;padding:0 .533333rem;white-space:nowrap;color:#fff}", ""]);

// exports
